"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = fetchCartCount;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var _Logger = _interopRequireDefault(require("./util/Logger"));

var loggerInstance = new _Logger.default('fetchCartCount');

function fetchCartCount(_x) {
  return _fetchCartCount.apply(this, arguments);
}

function _fetchCartCount() {
  _fetchCartCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jwt) {
    var hostname, url, requestOptions, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", 0);

          case 2:
            hostname = (0, _uigCurrentEnvironmentUtil.getHostname)('api2');
            url = "https://".concat(hostname, "/v1/web-cart-orch/cart/v1/carts/default/projects/ids");
            requestOptions = {
              headers: {
                Authorization: "Bearer ".concat(jwt),
                'SFly-Apikey': (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() !== 'production' ? 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG' : 'uWrM911sdIvHivflYxyiHlGgmlgoaV0m'
              }
            };
            _context.prev = 5;
            _context.next = 8;
            return (0, _uigCdnLibraries.polyfillFetch)();

          case 8:
            _context.next = 10;
            return window.fetch(url, requestOptions).then(function (res) {
              return res.json();
            });

          case 10:
            response = _context.sent;
            return _context.abrupt("return", response && response.itemsInCart);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            loggerInstance.error('Error: while fetching cart count', 'fetchCartCount', _context.t0);
            return _context.abrupt("return", _context.t0);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 14]]);
  }));
  return _fetchCartCount.apply(this, arguments);
}